import React from "react";
import { inject, observer } from "mobx-react";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";

import {
  Box,
  CircularProgress,
  Tab,
  Tabs,
  Typography
} from "@material-ui/core";

import EditRoomForm from "../forms/EditRoomForm";
import EditSensorForm from "../forms/EditSensorForm";
import OneClickCalibrationForm from "../forms/OneClickCalibrationForm";

import RoomSensorComparator from "./RoomSensorComparator";

import RoomTimeline from "./RoomTimeline";

import "typeface-open-sans";

const styles = () => ({});

class UnstyledRoomCardAdmin extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      tab: 0
    };
  }

  setLoading(l) {
    this.setState(state => ({
      ...state,
      loading: l
    }));
  }

  setTab(t) {
    this.setState(state => ({
      ...state,
      tab: t
    }));
  }

  enableSensorGroup(id) {
    const room = this.props.rootStore.roomStore.rooms.get(this.props.room.id);
    this.setLoading(true);
    room.addSensorGroupsByIds([id]).then(() => {
      room.pullReadings().then(() => {
        this.setLoading(false);
      });
    });
  }

  disableSensorGroup(id) {
    const room = this.props.rootStore.roomStore.rooms.get(this.props.room.id);
    this.setLoading(true);
    room.removeSensorGroupsByIds([id]).then(() => {
      room.pullReadings().then(() => {
        this.setLoading(false);
      });
    });
  }

  componentDidMount() {
    this.setLoading(true);
    const room = this.props.rootStore.roomStore.rooms.get(this.props.room.id);
    Promise.all([
      room.pullSensorGroups(),
      room.pullPotentialSensorGroups()
    ]).then(() => {
      Promise.all(
        room.potential_sensor_groups.map(sg => sg.pullSensors())
      ).then(() => {
        Promise.all(
          [].concat.apply(
            [],
            room.sensor_groups.map(sg =>
              sg.sensors.map(s => s.pullMeasurements())
            )
          )
        ).then(() => {
          this.setLoading(false);
        });
      });
    });
  }

  render() {
    const classes = this.props.classes;

    const room = this.props.room;

    let sensor_groups = [];
    let enabled_sensor_groups = new Set();
    let disabled_sensor_groups = new Set();

    room.sensor_groups.forEach(sg => {
      enabled_sensor_groups.add(sg.id);
      sensor_groups.push(sg);
    });

    room.potential_sensor_groups.forEach(sg => {
      if (!enabled_sensor_groups.has(sg.id)) {
        disabled_sensor_groups.add(sg.id);
        sensor_groups.push(sg);
      }
    });

    if (this.state.loading) {
      return (
        <Box className={classes.Container}>
          <CircularProgress className={classes.Progress} />
        </Box>
      );
    }

    let sensor_elements = {};
    sensor_groups.forEach(sg => {
      sg.sensors.forEach(s => {
        sensor_elements[s.id] = (
          <Box key={s.id} style={{ marginLeft: "2rem" }}>
            <Typography variant="h6">
              {s.human_name} - {s.notesFirstValue() || "n/a"}
            </Typography>
            <EditSensorForm
              sensor={s}
              room={room}
              notifications={this.props.rootStore.notificationStore}
            />
          </Box>
        );
      });
    });

    const elem = (
      <Box style={{ backgroundColor: "white" }}>
        <Tabs
          value={this.state.tab}
          onChange={(e, v) => this.setTab(v)}
          indicatorColor="primary"
          textColor="primary"
          centered
        >
          <Tab label="Sensors" />
          <Tab label="Room" />
        </Tabs>
        {this.state.tab === 0 ? (
          <RoomSensorComparator
            room={room}
            sensorElements={sensor_elements}
            enableSensorGroup={sg => this.enableSensorGroup(sg)}
            disableSensorGroup={sg => this.disableSensorGroup(sg)}
          />
        ) : (
          <Box>
            <EditRoomForm
              room={room}
              notifications={this.props.rootStore.notificationStore}
            />

            <Typography variant="h3">One-click Calibration</Typography>
            <OneClickCalibrationForm room={room} />

            <RoomTimeline room={room} />
          </Box>
        )}
      </Box>
    );

    return elem;
  }
}

export default withRouter(
  withStyles(styles)(
    inject(stores => ({
      rootStore: stores.rootStore
    }))(observer(UnstyledRoomCardAdmin))
  )
);
